import { createResourceStore } from './createResourceStore';
import { enrichWithDeviceInfo } from '../shared/lib/deviceInfo';

const useTransactionStore = createResourceStore({
  endpoint: '/admin/transactions',
  collectionKey: 'transactions',
  itemKey: 'transaction',
  hasCreate: false,
  enrichUpdate: enrichWithDeviceInfo,
  extraState: { transaction: null },
  mapListParams: (userId, orgId, status) => ({
    userId,
    orgId,
    status,
  }),
  methods: {
    fetch: 'fetchTransactions',
    update: 'updateTransaction',
    delete: 'deleteTransaction',
  },
});

export default useTransactionStore;
